import imageParams from './imageParams';

const iconizeImageUrl = (url, { size = 36 } = {}) => {
  if (!url) return url;

  return imageParams(
    url, {
      fit: 'crop',
      w: size,
      h: size,
      auto: 'compress'
    }
  );
};

export default iconizeImageUrl;
